<template>
  <div :class="['modal-header-container', { 'modal-header-secundario': secundario }]">
    <div v-if="icone" :class="['modal-header-icone', cor]">
      <font-awesome-icon :icon="icone" />
    </div>
    <div :class="['modal-header-padrao', { 'modal-header-mini': mini }]">
      <h5>{{ titulo }}</h5>
      <font-awesome-icon
        v-if="!(mini || secundario)"
        @click="close"
        class="modal-header-close"
        icon="times"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    close: Function,
    mini: Boolean,
    secundario: Boolean,
    titulo: String,
    icone: String,
    cor: String
  }
};
</script>

<style lang="scss" scoped>
.modal-header-container {
  width: 100%;
}
.modal-header-icone {
  display: flex;
  justify-content: center;
  font-size: 36px;
  margin-bottom: 10px;
  color: var(--cinza3);
}
.modal-header-padrao {
  display: flex;
  // align-items: center;
  // height: 24px;
  justify-content: space-between;
  > h5 {
    font-family: "Roboto Condensed";
    font-weight: 700;
    color: var(--azul4);
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}
.modal-header-close {
  height: 24px;
  color: var(--vermelho3) !important;
  cursor: pointer;
}
.modal-header-mini {
  justify-content: center;
}
.modal-header-secundario {
  background: var(--cinza0);
  width: calc(100% + 28px);
  border-bottom: 1px solid var(--cinza03);
  border-top: 1px solid var(--cinza03);
  margin: 0 0 0 -14px;
  padding: 14px;
}

.azul {
  color: var(--azul2);
}
.vermelho {
  color: var(--vermelho2);
}
.verde {
  color: var(--verde2);
}
.laranja {
  color: var(--laranja2);
}
</style>
